import { useEffect, useState } from "react";
import { fetchSucursales } from "../../../controller/sucursalController";
import { fetchEmpleadosPorSucursal } from "../../../controller/empleadoController";
import { useNavigate } from "react-router-dom";
import { Container, Table, Button } from "react-bootstrap";
import { PencilSquare, Plus } from "react-bootstrap-icons";

function EmpleadosView() {
  const [sucursales, setSucursales] = useState([]);
  const [empleados, setEmpleados] = useState({});
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const obtenerSucursales = async () => {
      try {
        const data = await fetchSucursales();
        setSucursales(data);
      } catch (error) {
        console.error('Error al obtener las sucursales:', error);
      }
    };
    obtenerSucursales();
  }, []);

  const handleSucursalChange = async (sucursalId) => {
    if (selectedSucursal === sucursalId) {
      setSelectedSucursal(null);
      return;
    }

    setSelectedSucursal(sucursalId);

    if (!empleados[sucursalId]) {
      try {
        const data = await fetchEmpleadosPorSucursal(sucursalId);
        setEmpleados((prevEmpleados) => ({
          ...prevEmpleados,
          [sucursalId]: data,
        }));
      } catch (error) {
        console.error(`Error al obtener empleados de la sucursal ${sucursalId}:`, error);
      }
    }
  };

  const handleCreateEmpleado = () => {
    navigate('/empleados/createEmpleado');
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Empleados</h1>
        <Button variant="primary" onClick={handleCreateEmpleado}>
          <Plus className="me-2" /> Crear Empleado
        </Button>
      </div>

      {sucursales.map((sucursal) => (
        <div key={sucursal.id} className="mb-4 border rounded p-3">
          <div
            className="d-flex justify-content-between align-items-center"
            onClick={() => handleSucursalChange(sucursal.id)}
            style={{ cursor: "pointer" }}
          >
            <h5 className="mb-0">{sucursal.name}</h5>
            <span>
              {selectedSucursal === sucursal.id ? (
                <i className="bi bi-chevron-up"></i>
              ) : (
                <i className="bi bi-chevron-down"></i>
              )}
            </span>
          </div>

          {selectedSucursal === sucursal.id && (
            <div className="mt-3">
              {empleados[sucursal.id] && empleados[sucursal.id].length > 0 ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Privilegio</th>
                      <th>Cédula</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empleados[sucursal.id].map((empleado) => (
                      <tr key={empleado.id}>
                        <td>{empleado.nombre}</td>
                        <td>{empleado.privilegio === 2 ? "Administrador" : "Usuario"}</td>
                        <td>{empleado.cedula}</td>
                        <td>
                          <Button
                            variant="light"
                            size="sm"
                            onClick={() =>
                              navigate("/empleados/editEmpleado", {
                                state: { equipo: empleado },
                              })
                            }
                          >
                            <PencilSquare color="blue" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p>No hay empleados para esta sucursal.</p>
              )}
            </div>
          )}
        </div>
      ))}
    </Container>
  );
}

export default EmpleadosView;
